/** Se il token è scaduto all'istante `nowMs`; senza scadenza leggibile non lo è. */
export function isTokenExpired(payload: { exp?: number } | null, nowMs: number) {
  const exp = payload?.exp;
  return exp ? nowMs >= exp * 1000 : false;
}
